/* managedSchedules.js */

"use strict";

const MANAGED_BY = {
    exposureManagementPrefs: {
        scheduleName: "Exposure Re-qualification",
        settingsName: "Titan AI > Exposure Management",
        path: "/frontend/settings/titan-ai/exposure",
    },
};

function readManagedBy(triggerType) {
    if (!triggerType) {
        return undefined;
    }
    if (typeof triggerType.getProperty === "function") {
        return triggerType.getProperty("managedBy");
    }
    return triggerType.managedBy;
}

function managerFor(triggerType) {
    const key = readManagedBy(triggerType);
    return typeof key === "string" && Object.prototype.hasOwnProperty.call(MANAGED_BY, key)
        ? MANAGED_BY[key]
        : undefined;
}

const SYSTEM_WORK_TYPES = [
    "retrieveSupportData",
    "runDataRetention",
    "networkDiscovery",
    "commitAndPush",
];

function isSystemTriggerType({workType, isUserActionSync, managedBy}) {
    if (typeof managedBy === "string" && Object.prototype.hasOwnProperty.call(MANAGED_BY, managedBy)) {
        return true;
    }
    if (workType === "dataSync") {
        return !isUserActionSync;
    }
    return SYSTEM_WORK_TYPES.includes(workType);
}

function managerForKey(key) {
    return typeof key === "string" && Object.prototype.hasOwnProperty.call(MANAGED_BY, key)
        ? MANAGED_BY[key]
        : undefined;
}

function refusalMessage(manager, action = "deleted") {
    return (
        "Sorry! The " +
        manager.scheduleName +
        " schedule cannot be " +
        action +
        ". Go to <a class='sys-schedule-err' href='" +
        window.location.origin +
        manager.path +
        "'>System Settings > " +
        manager.settingsName +
        "</a> and disable the schedule."
    );
}

module.exports = {
    MANAGED_BY,
    SYSTEM_WORK_TYPES,
    readManagedBy,
    managerFor,
    managerForKey,
    isSystemTriggerType,
    refusalMessage,
};
